module.exports = __webpack_public_path__ + "img/142.784ceac6.jpg";